export const ConsentCheckbox = ({ checked, onChange, testId = 'consent-checkbox' }) => (
  <label className="flex items-start gap-2 cursor-pointer" data-testid={testId}>
    <input
      type="checkbox"
      checked={checked}
      onChange={(e) => onChange(e.target.checked)}
      className="mt-0.5 w-4 h-4 rounded border-brand-border text-brand-green focus:ring-brand-green"
      required
      data-testid={`${testId}-input`}
    />
    <span className="text-xs text-brand-muted leading-relaxed">
      Li e aceito os{' '}
      <a href="/termos-e-condicoes" target="_blank" rel="noopener noreferrer" className="text-brand-green underline" data-testid={`${testId}-terms-link`}>
        Termos de Serviço
      </a>{' '}
      e a{' '}
      <a href="/privacidade" target="_blank" rel="noopener noreferrer" className="text-brand-green underline" data-testid={`${testId}-privacy-link`}>
        Política de Privacidade
      </a>.
    </span>
  </label>
);
